import { createSlice } from "@reduxjs/toolkit";
import { Option } from "~/types/component";
import {
  getPrefectures,
  getContacts,
  getBusinesses,
  getCategories,
} from "./action";

export type MasterState = {
  isInit: boolean; // 全てのマスターデータ取得処理を完了しているかどうか
  isPrefectureInit: boolean;
  isBusinessInit: boolean;
  isContactInit: boolean;
  isCategoryInit: boolean;
  prefectures: Option[];
  businesses: Option[];
  contacts: Option[];
  categories: Option[];
};

const initialState: MasterState = {
  isInit: false,
  isPrefectureInit: false,
  isBusinessInit: false,
  isContactInit: false,
  isCategoryInit: false,
  prefectures: [],
  businesses: [],
  contacts: [],
  categories: [],
};

const isInit = (
  state: MasterState,
  key: "prefecture" | "business" | "contact" | "category"
) => {
  let {
    isPrefectureInit,
    isBusinessInit,
    isContactInit,
    isCategoryInit,
  } = state;
  switch (key) {
    case "prefecture":
      isPrefectureInit = true;
      break;
    case "business":
      isBusinessInit = true;
      break;
    case "contact":
      isContactInit = true;
      break;
    case "category":
      isCategoryInit = true;
      break;
  }
  return isPrefectureInit && isBusinessInit && isContactInit && isCategoryInit;
};

const masterModule = createSlice({
  name: "master",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // 都道府県 取得
    builder.addCase(getPrefectures.pending, (state) => {
      // 処理時
      return {
        ...state,
        isPrefectureInit: false,
      };
    });
    builder.addCase(getPrefectures.rejected, (state) => {
      // 失敗時
      return {
        ...state,
        isInit: isInit(state, "prefecture"),
        isPrefectureInit: true,
        prefectures: [],
      };
    });
    builder.addCase(getPrefectures.fulfilled, (state, action) => {
      // 成功時
      return {
        ...state,
        isInit: isInit(state, "prefecture"),
        isPrefectureInit: true,
        prefectures: action.payload,
      };
    });

    // 連絡方法 取得
    builder.addCase(getContacts.pending, (state) => {
      // 処理時
      return {
        ...state,
        isContactInit: false,
      };
    });
    builder.addCase(getContacts.rejected, (state) => {
      // 失敗時
      return {
        ...state,
        isInit: isInit(state, "contact"),
        isContactInit: true,
        contacts: [],
      };
    });
    builder.addCase(getContacts.fulfilled, (state, action) => {
      // 成功時
      return {
        ...state,
        isInit: isInit(state, "contact"),
        isContactInit: true,
        contacts: action.payload,
      };
    });

    // 業態 取得
    builder.addCase(getBusinesses.pending, (state) => {
      // 処理時
      return {
        ...state,
        isBusinessInit: false,
      };
    });
    builder.addCase(getBusinesses.rejected, (state) => {
      // 失敗時
      return {
        ...state,
        isInit: isInit(state, "business"),
        isBusinessInit: true,
        businesses: [],
      };
    });
    builder.addCase(getBusinesses.fulfilled, (state, action) => {
      // 成功時
      return {
        ...state,
        isInit: isInit(state, "business"),
        isBusinessInit: true,
        businesses: action.payload,
      };
    });

    // ノートカテゴリ 取得
    builder.addCase(getCategories.pending, (state) => {
      // 処理時
      return {
        ...state,
        isCategoryInit: false,
      };
    });
    builder.addCase(getCategories.rejected, (state) => {
      // 失敗時
      return {
        ...state,
        isInit: isInit(state, "category"),
        isCategoryInit: true,
        categories: [],
      };
    });
    builder.addCase(getCategories.fulfilled, (state, action) => {
      // 成功時
      return {
        ...state,
        isInit: isInit(state, "category"),
        isCategoryInit: true,
        categories: action.payload,
      };
    });
  },
});

export {
  getPrefectures,
  getBusinesses,
  getContacts,
  getCategories,
} from "./action";

export default masterModule;
